export const zero = (_: any) => 0;
